import angular from 'angular';
import _ from 'lodash';
import * as devices from '../../../modules/devices';
import * as tracking from '../../../modules/tracking';
import { constants, helpers } from '../../../modules/dokbot';
export class DokbotService {
    constructor($window, trackingFactory, globalUi, $timeout, VideoProviderFactory, enableCameraErrorHandler, patientCheckInModalService, modalsService, $ngRedux, Room) {
        this.$window = $window;
        this.trackingFactory = trackingFactory;
        this.globalUi = globalUi;
        this.$timeout = $timeout;
        this.VideoProviderFactory = VideoProviderFactory;
        this.enableCameraErrorHandler = enableCameraErrorHandler;
        this.patientCheckInModalService = patientCheckInModalService;
        this.modalsService = modalsService;
        this.$ngRedux = $ngRedux;
        this.Room = Room;
    }
    initDoxybot(room) {
        if (room)
            this.room = room;
        this.modalsService.open('doxybotCheckin');
        this.$timeout(() => {
            this.$window.Dokbot.RuntimeComponent({
                ...this.createDokbotConfig(),
            }).render('.doxybotCheckin_modal');
        }, 0);
    }
    createDokbotConfig() {
        let name = '';
        let passcode = '';
        const doxybotElem = document.querySelector('.doxybotCheckin_modal');
        let proceedWithoutMedia = false;
        const onEvent = (event) => {
            if (event.name === 'nameSubmitted') {
                name = event.value;
            }
            else if (event.name === 'passcodeSubmitted') {
                passcode = event.value;
                this.Room.prototype$isValidPasscode({ id: this.room.id }, { passcode })
                    .$promise.then((result) => {
                    event.callback(result.isValid);
                })
                    .catch((err) => console.error(err));
            }
            else if (event.name === 'stepEvent') {
                if (event.value === 'bye') {
                    this.modalsService.close();
                    doxybotElem.classList.remove('ready');
                    this.$timeout(() => {
                        this.initDoxybot();
                    }, this.globalUi.PATIENT_MODAL_RESET_WAIT_TRANSITION_TIME);
                }
            }
            else if (event.name === 'tracking') {
                if (event.value === 'media-access-denied:Continue-Without-clicked') {
                    proceedWithoutMedia = true;
                }
                if (event.value === 'start') {
                    this.trackingFactory.global.track('Checkin Started', {
                        user_type: 'patient',
                        checkin_type: 'dokbot',
                        room_id: this.room.id,
                        plan_type: undefined,
                    });
                }
            }
        };
        const onCompletion = async ({ consultation }) => {
            await this.triggerCheckin(name, passcode);
            await this.$ngRedux.dispatch(devices.actions.updateDevices());
            const hasMediaAccess = devices.selectors.hasMediaAccess(this.$ngRedux.getState());
            this.trackingFactory.global.track('Checkin Completed', {
                user_type: 'patient',
                checkin_type: 'dokbot',
                room_id: tracking.helpers.getContextRoomId(),
                microphone: _.get(consultation, 'data.devices.microphone'),
                camera: _.get(consultation, 'data.devices.camera'),
                media_access_granted: hasMediaAccess,
                proceed_without_media: proceedWithoutMedia,
                plan_type: undefined,
            });
            if (!hasMediaAccess) {
                try {
                    await this.VideoProviderFactory.activeProvider.enableWebcam();
                }
                catch (err) {
                    this.enableCameraErrorHandler.onPatientCheckIn(err);
                    throw err;
                }
            }
        };
        const onReady = () => {
            if (doxybotElem) {
                doxybotElem.classList.add('ready');
            }
        };
        return {
            workflowId: 'doxyme-check-in-current',
            consultationId: '+',
            closeable: false,
            closeOnExit: true,
            onReady,
            onEvent,
            onCompletion,
            errorKitOverride: {
                id: constants.DOKBOT_KIT_ID,
                url: constants.DOKBOT_KIT_URL,
            },
            params: {
                provider: this.room.getDisplayName(),
                ...(this.room.usePasscode && { usepasscode: this.room.usePasscode }),
                ...(this.room.tosURL && { tosurl: this.room.tosURL }),
            },
        };
    }
    async triggerCheckin(name, passcode) {
        return await this.patientCheckInModalService.checkIn({
            room: this.room,
            patient: {
                username: name,
                passcode,
            },
            skipSegmentTrack: true,
        });
    }
    isSupported() {
        const isSupportedDokbot = this.$window.Dokbot && this.$window.Dokbot.meta.isBrowserSupported;
        if (!isSupportedDokbot) {
            helpers.dokbotTrackError(constants.DOKBOT_TYPE_CHECKIN);
        }
        return isSupportedDokbot;
    }
    close() {
        return this.modalsService.close();
    }
}
export default angular
    .module('doxy.common.services.dokbotService', [])
    .service('dokbotService', DokbotService).name;
